export const D28 = {
    "columns": 12,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "combo",
        "colorTheme": 'colorTheme1',
        "title": "Customer Group Performance",
        "xAxis": "",
        "yAxis": "Sales",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Actual Sales',
                        "value": 'ActualSales(Value)',
                        "type": 'column'
                    },
                    {
                        "name": 'LY Sales',
                        "value": 'LYSales(Value)',
                        "type": 'column'
                    },
                    {
                        "name": 'Growth %',
                        "value": 'Growth(Value)',
                        "type": 'line',
                        "percent": true
                    }
                ],
                "title": 'CustomerGroup',
                "endpoint": "D28",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "DistrictManagerCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "CustomerGroup",
                        "selectedTitle": "Channel",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 2,
                                "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": "colorTheme1",
                                    "title": "Channel",
                                    "binding": {
                                        "data": {
                                            "columns": [
                                                {
                                                    "name": 'Channel',
                                                    "columnName": 'DistributorCode',
                                                    "width": '180px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                },
                                                {
                                                    "name": 'Actual Sales',
                                                    "columnName": 'ActualSales(Value)',
                                                    "width": '140px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                },
                                                {
                                                    "name": 'LY Sales',
                                                    "columnName": 'LYSales(Value)',
                                                    "width": '135px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                },
                                                {
                                                    "name": 'Growth %',
                                                    "columnName": 'Growth(Value)',
                                                    "width": '135px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                }
                                            ],
                                            "title": 'DistributorCode',
                                            "endpoint": "D28.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "CustomerGroup", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {
                                                    "selectedValueColumn": "CustomerGroupDistributorCode",
                                                    "selectedTitle": "Customer",
                                                    "visual": [
                                                        {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                                "id": 1,
                                                                "type": "advancedTable",
                                                                "colorTheme": "colorTheme1",
                                                                "title": "Customer",
                                                                "binding": {
                                                                    "data": {
                                                                        "columns": [
                                                                            {
                                                                                "name": 'Customer Name',
                                                                                "columnName": 'CustomerName',
                                                                                "width": '300px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                                "sum": false
                                                                            },
                                                                            {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales(Value)',
                                                                                "width": '140px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true
                                                                            },
                                                                            {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales(Value)',
                                                                                "width": '135px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true
                                                                            },
                                                                            {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth(Value)',
                                                                                "width": '135px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                            }
                                                                        ],
                                                                        "title": 'CustomerName',
                                                                        "endpoint": "D28.2",
                                                                        "parameters": [
                                                                            { "key": "FromMonth", "value": "2024" },
                                                                            { "key": "FromYear", "value": "1" },
                                                                            { "key": "ToMonth", "value": "2024" },
                                                                            { "key": "ToYear", "value": "1" },
                                                                            { "key": "DistrictManagerCode", "value": "" },
                                                                            { "key": "CustomerGroupDistributorCode", "value": "" },
                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                        ]
                                                                    },
                                                                    "context": {
                                                                        "point": {
                                                                            "onClick": {
                                                                                "selectedValueColumn": "CustomerGroupDistributorCodeCustomerCode",
                                                                                "selectedTitle": "Product",
                                                                                "visual": [
                                                                                    {
                                                                                        "columns": 12,
                                                                                        "rows": 2,
                                                                                        "visual": {
                                                                                            "id": 1,
                                                                                            "type": "advancedTable",
                                                                                            "colorTheme": "colorTheme1",
                                                                                            "title": "Product",
                                                                                            "binding": {
                                                                                                "data": {
                                                                                                    "columns": [
                                                                                                        {
                                                                                                            "name": 'Product Name',
                                                                                                            "columnName": 'ItemName',
                                                                                                            "width": '300px',
                                                                                                            "align": "left",
                                                                                                            "sortable": true,
                                                                                                            "sum": false
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Actual Sales',
                                                                                                            "columnName": 'ActualSales(Value)',
                                                                                                            "width": '140px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": true
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'LY Sales',
                                                                                                            "columnName": 'LYSales(Value)',
                                                                                                            "width": '135px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": true
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Growth %',
                                                                                                            "columnName": 'Growth(Value)',
                                                                                                            "width": '135px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": false,
                                                                                                            "percent": true
                                                                                                        }
                                                                                                    ],
                                                                                                    "title": 'ItemName',
                                                                                                    "endpoint": "D28.3",
                                                                                                    "parameters": [
                                                                                                        { "key": "FromMonth", "value": "2024" },
                                                                                                        { "key": "FromYear", "value": "1" },
                                                                                                        { "key": "ToMonth", "value": "2024" },
                                                                                                        { "key": "ToYear", "value": "1" },
                                                                                                        { "key": "DistrictManagerCode", "value": "" },
                                                                                                        { "key": "CustomerGroupDistributorCodeCustomerCode", "value": "" },
                                                                                                        { "key": "ConfigTypeCode", "value": "" }
                                                                                                    ]
                                                                                                },
                                                                                                "context": {
                                                                                                    "point": {
                                                                                                        "onClick": {

                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}